import _ from 'underscore';
import Backbone from 'backbone';
import { parseSync } from '@bingads-webui/safe-json';
import template from './import-failure-details-table.pug';

const entityLocalizedKeyMapping = {
  Campaigns: 'Import_ImportSummary_Campaigns',
  Adgroups: 'Import_ImportSummary_AdGroups',
  'Ad Extension': 'Import_ImportSummary_AdExtensions',
  Ads: 'Import_ImportSummary_Ads',
  Keywords: 'Import_ImportSummary_Keywords',
  'Negative Keywords': 'Import_ErrorTable_NegativeKeywords',
  'Shared Negative Keywords': 'Import_ImportSummary_SharedNegativeKeyword',
  'Campaign Negative Keyword List Associations': 'Import_CampaignNegativeKeywordListAssociation',
  NegativeSites: 'Import_ErrorTable_NegativeSites',
  ProductScopes: 'Import_ErrorTable_ProductScopes',
  'Product Partitions': 'Import_ErrorTable_ProductPartitions',
  Targets: 'CampaignImport_ImportSummaryTargets',
  Labels: 'Import_ErrorTable_Labels',
  CampaignLabels: 'Import_ErrorTable_CampaignLabels',
  AdGroupLabels: 'Import_ErrorTable_AdGroupLabels',
  AdLabels: 'Import_ErrorTable_AdLabels',
  KeywordLabels: 'Import_ErrorTable_KeywordLabels',
  'Other items': 'Import_ImportSummary_Others',
  'Campaign DSA Exclusion': 'Import_ImportSummary_CampaignDSACriterion',
  'AdGroup DSA Auto Tartget and Exclusion': 'Import_ImportSummary_AdGroupDSACriterion',
  'AdGroup DSA Auto Target and Exclusion': 'Import_ImportSummary_AdGroupDSACriterion',
};

export class ImportFailureDetailsTableView extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.i18n = this.options.i18n;
    this.i18nAmdLoader = this.options.i18nAmdLoader;

    this.failureReasonsColumnsMapping = {
      // 17015 ImportTotalRowsExceedLimit
      17015: [{
        columnName: '',
        field: 'EntityDescription',
      }, {
        columnName: this.i18n.get('Import_ErrorTable_ImportedCount'),
        field: 'ImportedCount',
      }, {
        columnName: this.i18n.get('Import_ErrorTable_LimitCount'),
        field: 'LimitCount',
      }],
    };

    this.entityDescriptionMapping = {};
    _.each(entityLocalizedKeyMapping, (val, key) => {
      this.entityDescriptionMapping[key] = this.i18n.get(val);
    });
  }

  render() {
    this.$el.html(template(_.extend({
      isForVNext: this.options.isForVNext,
      ariaLabel: this.i18n.get('Import_ErrorTable_DemandLimitError'),
    }, this.formatData())));
    this.$('.import-error-message').html(this.options.message);
    return this;
  }

  /*
  Sample data:
    {
      ErrorCode: 17015,
      ErrorDetail: [
        {
          ImportedCount: 100,
          LimitCount: 2000000,
          EntityDescription: "Negative Keywords",
          HasExceededLimit: false
        }
      ]
    }
  Sample formatted data:
    {
      columns: ['', 'How many you want to import', 'Maximum import limit'],
      data: [{
        values: ['Negative Keywords', 100, 2000000],
        hasError: false
      }]
    };
  */
  formatData() {
    const { data } = this.options;
    const reason = this.options.failureReason; // error code

    const result = {};

    if (!data) {
      return result;
    }

    const reasonColumnsMapping = this.failureReasonsColumnsMapping[reason];
    let failureDetailsData = parseSync(data) || []; //eslint-disable-line

    if (reasonColumnsMapping && reasonColumnsMapping.length > 0 &&
      failureDetailsData && failureDetailsData.length > 0) {
      result.columns = _.pluck(reasonColumnsMapping, 'columnName');
      result.data = _.map(failureDetailsData, (oneTypeFailureDetails) => {
        const values = _.chain(reasonColumnsMapping).pluck('field').map(columnField => oneTypeFailureDetails[columnField]).value();
        const hasError = oneTypeFailureDetails.HasExceededLimit;
        const formattedValues = _.map(values, (val) => {
          let tmp = val;

          if (_.isNumber(val)) {
            tmp = this.i18nAmdLoader.formatDecimal(val);
          } else if (_.isString(val)) {
            tmp = this.entityDescriptionMapping[tmp] || tmp;
          }

          return tmp || this.i18n.get('Import_LastImport_Dash');
        });

        return { values, hasError, formattedValues };
      });
    }

    return result;
  }
}
